import { type FC } from 'react'

import { IconShoppingCart } from '@redteclab/icons'

import { Button } from 'base-ui'

import {
  EXPERIMENTS_TRACK_EVENT_STICKY_BUY_BOX,
  experimentsTrackEvent,
} from '../../../../../experiments/eventTracking'
import { useGetExperimentForTenant } from '../../../../../experiments/hooks'
import { EXPERIMENT_NAME_STICKY_BUY_BOX } from '../../../../../experiments/model/EXPERIMENT_NAME_PER_TENANT'
import { EXPERIMENT_VARIATION } from '../../../../../experiments/model/EXPERIMENT_VARIATION'
import { useGlobalConfigContext } from '../../../../../global-config'
import { PRODUCT_ADD_TO_CART_FORM_ID } from '../../ProductAddToCartGroup/ProductAddToCartCta/ProductAddToCartCta'
import { useBuildAddToCartParams } from '../../ProductAddToCartGroup/ProductAddToCartCta/useBuildAddToCartParams'

/**
 * External button for mobile screens for submitting main add to cart form in {@link ProductAddToCartCta}
 */
export const ProductBuyBoxStickyAddToCart: FC = () => {
  const { disableCta } = useBuildAddToCartParams()
  const config = useGlobalConfigContext()
  const { isEnabled, variant } = useGetExperimentForTenant(
    EXPERIMENT_NAME_STICKY_BUY_BOX,
  )

  return (
    <Button
      className="px-4"
      data-qa-id="form-sticky-buy-box"
      disabled={disableCta}
      form={PRODUCT_ADD_TO_CART_FORM_ID}
      onClick={() => {
        if (isEnabled && variant === EXPERIMENT_VARIATION.DEFAULT) {
          experimentsTrackEvent(config, EXPERIMENTS_TRACK_EVENT_STICKY_BUY_BOX)
        }
      }}
      type="submit"
    >
      <IconShoppingCart className="size-6" />
    </Button>
  )
}
